import { privacyPoints } from "@/mocks/home";

export default function PrivacyPromise() {
  return (
    <section id="privacy" className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
        <div className="lg:col-span-5 relative order-2 lg:order-1">
          <div className="w-full h-[280px] sm:h-[360px] lg:h-[420px] rounded-lg overflow-hidden bg-secondary-100">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20a%20protective%20shield%20built%20from%20layered%20paper%20arcs%20guarding%20a%20small%20folded%20note%2C%20warm%20sage%20green%20and%20amber%20accents%20on%20cream%20background%2C%20geometric%20flat%20art%20with%20subtle%20paper%20texture%2C%20generous%20negative%20space%2C%20calm%20trustworthy%20mood%2C%20soft%20shapes%20and%20harmonious%20composition&width=900&height=900&seq=heiliao-privacy-shield&orientation=squarish"
              alt="黑料社区隐私与安全保护示意插画"
              title="黑料社区隐私保护 匿名爆料安全"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <span className="text-xs md:text-sm font-medium tracking-wide text-secondary-700">
            隐私与安全
          </span>
          <h3 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            保护爆料人安全，是我们审核里的第一条规则
          </h3>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            从提交流程到最终展示，社区在每一个环节都尽量减少可以定位到个人的信息，让你放心把线索交出来。
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {privacyPoints.map((point) => (
              <div
                key={point.id}
                className="rounded-lg bg-background-100 border border-background-200 p-5"
              >
                <span className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className={`${point.icon} text-xl text-secondary-700`}></i>
                </span>
                <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {point.title}
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}